import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import ArticleCard from '@/components/base/ArticleCard';

export default function ArticleGrid() {
  const latestArticles = [...articles]
    .sort((a, b) => new Date(b.publishDate).getTime() - new Date(a.publishDate).getTime());

  const featuredArticle = latestArticles[0];
  const gridArticles = latestArticles.slice(1, 7);
  const compactArticles = latestArticles.slice(7);

  return (
    <section className="py-8 md:py-10">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-2.5 mb-5">
          <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-secondary-500">
            <i className="ri-article-line text-background-50 text-base"></i>
          </div>
          <h2 className="text-lg md:text-xl font-bold text-foreground-950" style={{ fontFamily: "var(--font-heading)" }}>
            最新爆料
          </h2>
        </div>

        {featuredArticle && (
          <div className="mb-5">
            <ArticleCard
              variant="featured"
              slug={featuredArticle.slug}
              title={featuredArticle.title}
              excerpt={featuredArticle.excerpt}
              category={featuredArticle.category}
              categoryName={featuredArticle.categoryName}
              publishDate={featuredArticle.publishDate}
              readCount={featuredArticle.readCount}
              commentCount={featuredArticle.commentCount}
              imageUrl={featuredArticle.imageUrl}
              isHot={featuredArticle.isHot}
              isNew={featuredArticle.isNew}
            />
          </div>
        )}

        <div className="space-y-4 mb-5">
          {gridArticles.map((article) => (
            <ArticleCard
              key={article.id}
              variant="default"
              slug={article.slug}
              title={article.title}
              excerpt={article.excerpt}
              category={article.category}
              categoryName={article.categoryName}
              publishDate={article.publishDate}
              readCount={article.readCount}
              commentCount={article.commentCount}
              imageUrl={article.imageUrl}
              isHot={article.isHot}
              isNew={article.isNew}
            />
          ))}
        </div>

        <div className="pt-5 border-t border-background-200/70">
          <h3 className="text-sm font-semibold text-foreground-700 mb-3 flex items-center gap-2">
            <i className="ri-history-line text-accent-500"></i>
            往期热瓜
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
            {compactArticles.map((article) => (
              <ArticleCard
                key={article.id}
                variant="compact"
                slug={article.slug}
                title={article.title}
                excerpt={article.excerpt}
                category={article.category}
                categoryName={article.categoryName}
                publishDate={article.publishDate}
                readCount={article.readCount}
                commentCount={article.commentCount}
                imageUrl={article.imageUrl}
              />
            ))}
          </div>
        </div>

        <div className="text-center mt-8">
          <Link
            to="/category/yule-bagua"
            className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full bg-background-100 text-foreground-700 text-sm font-medium hover:bg-background-200 transition-colors whitespace-nowrap"
          >
            加载更多爆料 <i className="ri-arrow-down-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}